import { Component, OnInit } from '@angular/core';
import { SearchParams } from 'src/app/common';

@Component({
  templateUrl: './subscribe-page.component.html',
  styleUrls: ['./subscribe-page.component.scss']
})
export class SubscribePageComponent implements OnInit {

  constructor() { }

  searchParams = new SearchParams();

  ngOnInit(): void {
  }

}
